export default __webpack_public_path__ + "static/media/money.f6fa67f8.svg";